// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"src_views_Bridge_Jitsi_vue":"094bda14","src_views_Bridge_index_vue":"777ca76a","src_views_Layout_vue":"db3e18f4"}[chunkId] + ".js";
};